import axios from "axios";

import { getHeader } from "../headers";

// ===================================
//  LOCATIONS
// ===================================
export const locationsAreLoading = () => {
	return {
		type: "LOCATIONS_ARE_LOADING"
	};
};

export const locationsHasError = err => {
	return {
		type: "LOCATIONS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const locationsSuccess = data => {
	return {
		type: "LOCATIONS_SUCCESS",
		payload: data.data
	};
};

export function getLocations() {
	return dispatch => {
		dispatch(locationsAreLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + `locations`, {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(locationsHasError(response.data.errors));
				} else {
					return dispatch(locationsSuccess(response));
				}
			})
			.catch(err => {
				dispatch(locationsHasError(err.response.data.message));
			});
	};
}

// ===================================
//  PROVINCES
// ===================================
export const provincesAreLoading = () => {
	return {
		type: "PROVINCES_ARE_LOADING"
	};
};

export const provincesHasError = err => {
	return {
		type: "PROVINCES_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const provincesSuccess = data => {
	return {
		type: "PROVINCES_SUCCESS",
		payload: data.data
	};
};

export function getProvinces(country) {
	return dispatch => {
		dispatch(provincesAreLoading());

		// Possibly ask for a specific country
		const params = !!country ? { country: country } : { country: "US" };

		return axios
			.get(process.env.REACT_APP_API_URL + "locations/provinces", {
				headers: getHeader(),
				params: params
			})
			.then(response => dispatch(provincesSuccess(response)))
			.catch(err => {
				console.log("getProvinces error:", err.response.statusText);
				dispatch(provincesHasError(err.response.statusText));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/locations.js